<template>
  <div class="main" v-if="loading == false">
    <div class="stat-section">
      <div class="wrapPortable Indica wrapStat">
        <div>
          <h1 class="indH1">Statistiques</h1>
          <h2 class="indH2">
            Resultats du dernier test
          </h2>
        </div>
      </div>
      <div
        v-if="tests !== null && Object.size(tests) !== 0 && tests !== undefined"
        class="stat-result"
      >
        <div class="Tabs tabsStats">
          <!--<a v-for="tab in tabs" :key="tab.name" v-on:click="activetab = tab.name" v-bind:class="[ activetab === tab.name ? 'active' : '' ]">{{tab.name}}</a>-->
          <ul class="boutonTableStat">
            <li
              v-for="tab in tabs"
              :key="tab.name"
              v-on:click="changePosition()"
              v-bind:class="[activetab === tab.name ? 'active' : '']"
            >
              <p>{{ tab.name }}</p>
            </li>
          </ul>
        </div>
        <Grid
          :heroes="gridData"
          :columns="gridColumns"
          v-if="activetab == 'Tableau'"
        ></Grid>
        <!--<canvas id = "schema" height="300" width="400" style="overflow: visible;" v-else>
            Votre navigateur ne supporte pas la balise canvas
          </canvas>-->
        <line-chart
          :data="data"
          v-if="activetab !== 'Tableau'"
          :colors="['#54c7da', '#ffc107', '#28a745']"
          xtitle="Date des Tests"
          ytitle="Résultats"
          class="lineChart"
        ></line-chart>
        <div class="calculPourcentage">
          <table>
            <thead>
              <tr>
                <th @click.prevent="infoCoube()">
                  Info
                </th>
                <th>
                  TestAD
                </th>
                <th>
                  TestDijon
                </th>
                <th>
                  TestEqui
                </th>
                <th>
                  TestSoupEp
                </th>
                <th>
                  TestSoupTr
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="(entry, index) in calcTab" :key="index">
                  {{ entry }}
                  <span
                    v-if="
                      definProgression(entry, index) == true &&
                        entry !== 'Progression Moyenne'
                    "
                    class="fa  fa-arrow-circle-up logoHaut"
                  ></span>
                  <span
                    v-else-if="
                      definProgression(entry, index) == false &&
                        entry !== 'Progression Moyenne'
                    "
                    class="fa fa-arrow-circle-down logoBas"
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="stat-result">
        <p>Vous n'avez pas de résultats actuellement</p>
      </div>
    </div>
  </div>
  <div class="main  mainLoader" v-else>
    <circleLoader :when="loading"></circleLoader>
  </div>
</template>

<script>
import { User } from "../controller/user.js";
import { Analyse } from "../controller/analyseResultat.js";
import Grid from "@/components/Grid";
import { hostUrl } from "../_helpers/global_var";
import circleLoader from "@/components/Circle-loader";
import Chart from "chart.js";
import Chartkick from "vue-chartkick";
Chartkick.use(Chart);
//définir une fonction qui va me permettre de ne pas me faire passer par lenght afin d'obtenir la longueur de mmon tableau d'objects
//define a function which will allow me not to pass by lenght in order to obtain the length of mmon array of objects
Object.size = function(obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

const axios = require("axios").default;
const formatDate = "france";
export default {
  name: "Statistiques",
  components: { Grid, circleLoader },
  data() {
    return {
      user: JSON.parse(localStorage.user) || [],
      tests: null,
      loading: false,
      activetab: "Courbe",
      tabs: [{ name: "Courbe" }, { name: "Tableau" }],
      gridColumns: [
        "date",
        "testAD",
        "testDijon",
        "testEqui",
        "testSoupEp",
        "testSoupTr"
      ],
      gridData: [],
      info: [
        { title: "Votre condition physique", underTitle: "Test d'équilibre" },
        {
          title: "Votre condition physique",
          underTitle: "Test de souplesse du tronc"
        },
        {
          title: "Votre condition physique",
          underTitle: "Test de souplesse des épaules"
        },
        { title: "Votre condition physique", underTitle: "Test assis debout" },
        {
          title: "Votre condition physique",
          underTitle: "Score d'activité physique de Dijon"
        },
        {
          title: "Votre condition physique",
          underTitle: "Score d'activité physique de Dijon"
        }
      ],
      data: "",
      allInfo: false
    };
  },

  created() {
    this.loading = true;
    if (typeof localStorage.user !== undefined && localStorage.length > 1) {
      if (localStorage.user.mail !== undefined) {
        this.user = JSON.parse(localStorage.user);
      }
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }
    if (
      typeof localStorage.resultats !== undefined &&
      localStorage.length > 2
    ) {
      try {
        JSON.parse(localStorage.resultats);
        this.allVideo = JSON.parse(localStorage.mesExercices);
        //console.log(this.allVideo);
      } catch (error) {
        this.appelApi();

        console.log("ko");
      }
      //console.log(this.tests);
      try {
        this.tests = JSON.parse(localStorage.resultats);
        this.defineCalcTab();
        this.defineGridData(this.tests);
      } catch (error) {
        this.tests = null;
      }
    } else {
      if (this.user !== undefined && this.user !== []) {
        axios

          .get(hostUrl + "/salarie/infoResultat/" + this.user.salarie_id)
          .then(
            response => (localStorage.resultats = JSON.stringify(response.data))
          )
          .catch(error => console.log(error));
        this.tests = JSON.parse(localStorage.resultats);
        this.defineCalcTab();
        this.defineGridData(this.tests);
      }
    }
    let lastResults = new Analyse(this.tests[8]);
    console.log(this.tests, lastResults.resultatFinal);
  },
  methods: {
    async appelApi() {
      await axios
        .get(hostUrl + "/salarie/infoResultat/" + this.user.salarie_id)
        .then(
          response => (localStorage.resultats = JSON.stringify(response.data))
        )
        .catch(error => console.log(error));
      this.loading = false;
    },
    defineGridData(array) {
      let koko = [];
      array.forEach(element => {
        let date = new Date(element.date);
        date.setTime();
        koko.push({
          date: element.date,
          testAD: element.testAssisDebout,
          testDijon: element.testDijon,
          testEqui: element.testEquilibre,
          testSoupEp: element.testSouplesseEpaules,
          testSoupTr: element.testSouplesseTronc
        });
      });

      for (let i = koko.length - 1; i >= 0; i--) {
        if (i == 0 || (i <= koko.length - 1 && i >= koko.length - 4))
          this.gridData.push(koko[i]);
      }
      //console.log(this.gridData);
      this.loading = false;
    },
    defineCalcTab() {
      let koko = {
        info: "Progression Moyenne",
        testAssisDebout: Number(0),
        testDijon: Number(0),
        testEquilibre: Number(0),
        testSouplesseEpaules: Number(0),
        testSouplesseTronc: Number(0)
      };

      for (let i = this.tests.length - 1; i >= 0; i--) {
        if (this.tests[i].testAssisDebout == null) {
          this.tests[i].testAssisDebout = 0;
        } else if (this.tests[i].testDijon == null) {
          this.tests[i].testDijon = 0;
        } else if (this.tests[i].testEquilibre == null) {
          this.tests[i].testEquilibre = 60;
        } else if (this.tests[i].testSouplesseEpaules == null) {
          this.tests[i].testSouplesseEpaules = 0;
        } else if (
          this.tests[i].testSouplesseTronc == null ||
          this.tests[i].testSouplesseTronc > 5
        ) {
          this.tests[i].testSouplesseTronc = 0;
        }

        koko.testAssisDebout += Number(this.tests[i].testAssisDebout);
        koko.testDijon += Number(this.tests[i].testDijon);
        koko.testEquilibre += Number(this.tests[i].testEquilibre);
        koko.testSouplesseEpaules += Number(this.tests[i].testSouplesseEpaules);
        koko.testSouplesseTronc += Number(this.tests[i].testSouplesseTronc);

        if (i == 0) {
          //console.log(koko, Object.size(this.tests));
          let lenght = Object.size(this.tests);

          koko.testAssisDebout = Math.round(koko.testAssisDebout / lenght);
          koko.testDijon = Math.round(koko.testDijon / lenght);
          koko.testEquilibre = Math.round(koko.testEquilibre / lenght);
          koko.testSouplesseEpaules = Math.round(
            koko.testSouplesseEpaules / lenght
          );
          koko.testSouplesseTronc = Math.round(
            koko.testSouplesseTronc / lenght
          );
        }
      }
      this.calcTab = koko;
      this.loading = false;
      //console.log(this.calcTab);
    },
    definProgression(entry, index) {
      if (index == "testAssisDebout") {
        if (this.gridData[0].testAD >= entry) {
          return true;
        } else {
          return false;
        }
      } else if (index == "testDijon") {
        if (this.gridData[0].testDijon >= entry) {
          return true;
        } else {
          return false;
        }
      } else if (index == "testEquilibre") {
        if (this.gridData[0].testEqui <= entry) {
          return true;
        } else {
          return false;
        }
      } else if (index == "testSouplesseEpaules") {
        if (this.gridData[0].testSoupEp >= entry) {
          return true;
        } else {
          return false;
        }
      } else if (index == "testSouplesseTronc") {
        if (this.gridData[0].testSoupTr >= entry) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    infoCoube() {
      if (this.allInfo == false) {
        this.allInfo = true;
        this.cavan();
      } else {
        this.allInfo = false;
        this.cavan();
      }
    },
    cavan() {
      //new Chartkick.LineChart("line", {"2013-02-10":11,"2013-02-11":6,"2013-02-12":3,"2013-02-13":2,"2013-02-14":5,"2013-02-15":3,"2013-02-16":8,"2013-02-17":6,"2013-02-18":6,"2013-02-19":12,"2013-02-20":5,"2013-02-21":5,"2013-02-22":3,"2013-02-23":1,"2013-02-24":10,"2013-02-25":1,"2013-02-26":3,"2013-02-27":2,"2013-02-28":3,"2013-03-01":2,"2013-03-02":8}, {download: true});

      var tests = JSON.parse(localStorage.resultats);
      var tests2 = [];
      var testsDate = "";
      var testInter = [];
      var testConf = [];

      if (tests.length > 10) {
        console.log(tests.length - 10, tests.length);
        for (let index = tests.length - 10; index < tests.length; index++) {
          let ki = tests[index];
          let Obki = new Analyse(ki);
          let result = Obki.resultatFinal;
          let date = tests[index].date;
          if (date !== null && date !== undefined) {
            testsDate = date.slice(0, 10);
            if (formatDate !== "france") {
              testsDate =
                date.slice(6, 10) +
                "-" +
                date.slice(3, 5) +
                "-" +
                date.slice(0, 2);
            }
          } else {
            testsDate = index;
          }
          tests2.push([testsDate, result]);
          testInter.push([testsDate, 41]);
          testConf.push([testsDate, 81]);
        }
        if (this.allInfo == false) {
          this.data = [{ name: "Votre Courbe de Résultats", data: tests2 }];
        } else {
          this.data = [
            { name: "Votre Courbe", data: tests2 },
            { name: "Niveau Intermediaire", data: testInter },
            { name: "Niveau Confirme", data: testConf }
          ];
        }
      } else {
        for (let index = 0; index < tests.length; index++) {
          let ki = tests[index];
          let Obki = new Analyse(ki);
          let result = Obki.resultatFinal;
          let date = tests[index].date;
          if (date !== null && date !== undefined) {
            testsDate = date.slice(0, 10);
            if (formatDate !== "france") {
              testsDate =
                date.slice(6, 10) +
                "-" +
                date.slice(3, 5) +
                "-" +
                date.slice(0, 2);
            }
          } else {
            testsDate = index;
          }
          tests2.push([testsDate, result]);
          testInter.push([testsDate, 41]);
          testConf.push([testsDate, 81]);
        }
        if (this.allInfo == false) {
          this.data = [{ name: "Votre Courbe de Résultats", data: tests2 }];
        } else {
          this.data = [
            { name: "Votre Courbe", data: tests2 },
            { name: "Niveau Intermediaire", data: testInter },
            { name: "Niveau Confirme", data: testConf }
          ];
        }
      }
      console.log(this.data);
    },
    changePosition() {
      if (this.activetab == "Courbe") {
        this.activetab = "Tableau";
      } else {
        this.activetab = "Courbe";
        this.cavan();
      }
    }
  },
  mounted() {
    //console.log(Object.size(this.tests), this.tests.lenght);
    if (this.activetab == "Courbe") {
      this.cavan();
    }
  },
  updated() {
    if (this.activetab == "Courbe") {
      //this.cavan();
    }
  }
};
</script>
<style>
@media screen and (min-width: 1100px){
  .stat-result{
    width: 100%;
  }
  .wrapStat{
    width: 100%;
    margin-left: 0;
  }
}
.lineChart{
  margin-left: auto;
  margin-right: auto;
}
.logoHaut {
  color: #54c7da;
}
.logoBas {
  color: #c41316;
}
.tabsStats {
  width: 80%;
  height: 35px;
  margin-left: auto;
  margin-right: auto;
}
.tabsStats ul {
  margin: 0;
  width: 100%;
}
.tabsStats li {
  margin-left: 0;
  text-align: center;
  width: 50%;
}
#schema {
  margin-left: auto;
  margin-right: auto;
}
.boutonTableStat {
  box-shadow: 0px 0px 10px 0px #aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistiques.vue